import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('insurances', storeModule.createStoreModule('insurances'))
